import React, { ReactNode } from "react";
import { Box, useStyleConfig, BoxProps } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { isWorkspaceCanvasPathname } from "@/views/Dashboard/Workspace/workspaceRoutes";

interface MainPanelProps extends BoxProps {
  variant?: string;
  children?: ReactNode;
}

function MainPanel(props: MainPanelProps) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("MainPanel", { variant });
  const { pathname } = useLocation();
  const workspaceCanvas = isWorkspaceCanvasPathname(pathname);
  const merged = workspaceCanvas
    ? {
        ...styles,
        float: "none",
        overflow: "hidden",
        width: "100%",
        maxHeight: "none",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }
    : styles;
  return (
    <Box __css={merged} {...rest}>
      {children}
    </Box>
  );
}

export default MainPanel;
